import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './DashboardSkeleton.module.css';

/**
 * Loading skeleton for the Dashboard page.
 * Mirrors the grid and hero layout of the active dashboard to
 * prevent layout shifts during data ingestion.
 */
export function DashboardSkeleton(): JSX.Element {
  return (
    <div className={skeletonStyles.dashboardShell} data-testid="dashboard-skeleton">
      {/* Leadership Quotes Skeleton */}
      <section className={skeletonStyles.cardSecondary}>
        <Skeleton width="40%" height={24} style={{ marginBottom: 'var(--spacing-4)' }} />
        <Skeleton width="100%" height={60} />
      </section>

      {/* Grid Section Skeleton */}
      <section className={skeletonStyles.sectionGrid}>
        {/* User Overview Skeleton */}
        <div className={skeletonStyles.card}>
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}
          >
            <Skeleton variant="circular" width={64} height={64} />
            <div style={{ flex: 1 }}>
              <Skeleton width="60%" height={24} style={{ marginBottom: 'var(--spacing-2)' }} />
              <Skeleton width="40%" height={18} />
            </div>
          </div>
          <Skeleton width="100%" height={100} />
        </div>

        {/* Leader Dashboard Skeleton */}
        <div className={skeletonStyles.card}>
          <Skeleton width="50%" height={24} style={{ marginBottom: 'var(--spacing-6)' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-3)' }}>
            <Skeleton width="100%" height={40} />
            <Skeleton width="100%" height={40} />
            <Skeleton width="100%" height={40} />
          </div>
        </div>
      </section>

      {/* Learning Resources Skeleton */}
      <section>
        <Skeleton width={200} height={28} style={{ marginBottom: 'var(--spacing-4)' }} />
        <div className={skeletonStyles.grid}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={skeletonStyles.resourceCard}>
              <Skeleton height={160} />
              <div className={skeletonStyles.resourceContent}>
                <Skeleton width="80%" height={20} style={{ marginBottom: 'var(--spacing-2)' }} />
                <Skeleton width="40%" height={16} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
